import { SET_ROUTE_TO_REDIRECT } from './redirect';
import { SELECT_ORGANIZATION_TOKEN } from './organizationSelection';
import { fetchOrganizationLogo } from './fetchOrganizationLogo';
import { getRouteToRedirect } from '../utils/getRouteToRedirect';

export const selectOrganizationFromUrl = orgId => (dispatch, getState) => {
  const state = getState();
  const organizationToken = Number(orgId);
  const routeToRedirect = getRouteToRedirect(state);
  dispatch({
    type: SET_ROUTE_TO_REDIRECT,
    payload: { routeToRedirect },
  });

  dispatch({
    type: SELECT_ORGANIZATION_TOKEN,
    payload: { selectedOrganizationToken: organizationToken },
  });

  return dispatch(fetchOrganizationLogo(organizationToken));
};
